import { faAngleDoubleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Timeline } from "primereact/timeline";

import { openlink } from "../utility";

export const HistoryItem = (props) => {
  const getTimeLineArrowIcon = () => (
    <div className="d-center w-100 mt-5">
      <div className="p-1 text-nowrap">
        {<FontAwesomeIcon icon={faAngleDoubleDown} />}
      </div>
    </div>
  );

  return (
    <div className="history-inner-item-wrapper">
      <div className="header-inner">
        <b>{props.time}</b>
      </div>
      <div
        className="name-link"
        onClick={() => {
          openlink(props.web_link);
        }}
      >
        <b>{props.heading}</b>
      </div>
      {props.postings ? (
        <Timeline
          className="w-full md:w-20rem"
          align="left"
          opposite={null}
          value={props.postings}
          content={(item) => {
            return (
              <div className="history-timeline-item">
                <div>
                  {item.title} |{" "}
                  <span className="history-time">{item.time}</span>
                </div>
                <div
                  className="description-inner"
                  dangerouslySetInnerHTML={{ __html: item.description }}
                ></div>
                {item.links && (
                  <div className="description-inner link-container">
                    {item.links.map((itemLink, index) => {
                      return (
                        <div className="link-item">
                          <a href={itemLink.url}>
                            - See my {itemLink.name}
                            <img src={itemLink.img} alt={itemLink.name} />
                            Profile
                          </a>
                          {itemLink.note ? "( " + itemLink.note + " )" : ""}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          }}
        />
      ) : (
        <>
          <div className="title-inner">{props.title}</div>
          <div
            className="description-inner"
            dangerouslySetInnerHTML={{ __html: props.description }}
          ></div>
          {props.links ? (
            <div className="description-inner link-container">
              {props.links.map((item, index) => {
                return (
                  <div className="link-item">
                    <a href={item.url}>
                      - See my {item.name}
                      <img src={item.img} alt={item.name} />
                      Profile
                    </a>
                    {item.note ? "( " + item.note + " )" : ""}
                  </div>
                );
              })}
            </div>
          ) : (
            ""
          )}
        </>
      )}
    </div>
  );
};
